import { Link } from 'react-router'
import { Routes } from '../../routes.ts'
import { RenderedMarkdown } from '../rendered-markdown.tsx'
import * as styles from './analysis-preferences-tab.css.ts'

type AnalysisPreferencesTabProps = { memory: string }

export const AnalysisPreferencesTab: React.FC<AnalysisPreferencesTabProps> = ({ memory }) => (
  <div className={styles.container}>
    <p className={styles.explanation}>
      The preferences below represent what was effective at the time of this analysis. To reference the current state,
      navigate to{' '}
      <Link to={Routes.OrganizationPage.createPath()} className={styles.link}>
        Organization preferences
      </Link>
      .
    </p>
    <div className={styles.contentPanel}>
      <RenderedMarkdown markdown={memory} />
    </div>
  </div>
)
